var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSmileyBad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1875 64.6875C17.5844 64.6875 4 51.1031 4 34.5C4 17.8969 17.5844 4.3125 34.1875 4.3125C50.7906 4.3125 64.375 17.8969 64.375 34.5C64.375 51.1031 50.7906 64.6875 34.1875 64.6875Z",
    fill: "#B1D4F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 43.9487L24.7969 47.2049C27.3382 44.6465 30.8036 43.125 34.5 43.125C38.1964 43.125 41.6618 44.6465 44.2031 47.4375L47.4375 44.1813C43.9721 40.6926 39.0435 38.8125 34.5 38.8125C30.4185 38.793 25.0279 40.46 21.5625 43.9487Z",
    fill: "#0000C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6811 28.1785L19.1308 25.6312L20.3994 22.3691L30.6851 26.3691C31.3335 26.6213 31.771 27.2336 31.7993 27.9288C31.8277 28.6239 31.4416 29.2699 30.8159 29.574L20.5302 34.574L19 31.4263L25.6811 28.1785Z",
    fill: "#0000C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1348 28.1785L48.6851 25.6312L47.4165 22.3691L37.1308 26.3691C36.4824 26.6213 36.0449 27.2336 36.0166 27.9288C35.9882 28.6239 36.3743 29.2699 37 29.574L47.2857 34.574L48.8159 31.4263L42.1348 28.1785Z",
    fill: "#0000C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmileyBad);
export default __webpack_public_path__ + "static/media/icon-smiley-bad.fbf500dd417b1e9772856a49d6b26742.svg";
export { ForwardRef as ReactComponent };